export const nonAccentVietnamese = (str : string) => {
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    return str;
}

export const stringFormatToFloat = (value) => {
    if (value == 0 || value == '0') {
        return parseFloat(value);
    } else if (value != undefined && value != '') {
        var data = parseFloat(value.toString().replace(/\,/g, '')).toFixed(2).replace('\.00', '');

        if (data.includes('.') && (data.endsWith('10') || data.endsWith('20') || data.endsWith('30') || data.endsWith('40') || data.endsWith('50') || data.endsWith('60') || data.endsWith('70') || data.endsWith('80') || data.endsWith('90'))) {
            return data.substring(0, data.length - 1);
        } else {
            return data
        }
    }
    return;
}

export const floatToStringFormat = (number) => {
    if (number) {
        var data = (parseFloat(number.toString())).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace('.00', '');
        if (data.includes('.') && (data.endsWith('10') || data.endsWith('20') || data.endsWith('30') || data.endsWith('40') || data.endsWith('50') || data.endsWith('60') || data.endsWith('70') || data.endsWith('80') || data.endsWith('90'))) {
            return data.substring(0, data.length - 1);
        }
        return data;
    }

    return;
}